import type {ColumnDef} from '@tanstack/react-table';

import i18n from '@/i18n';
import type {Event, Resident, User} from '@/services/graphqlHooks';
import eventSubTypes from '@/translation/eventSubTypes';
import eventTypes from '@/translation/eventTypes';

export type EventWithResidentAndUser = Event & {
  resident?: Resident;
  user?: User;
};

export const eventsColumns: ColumnDef<EventWithResidentAndUser>[] = [
  {
    header: i18n.t('ID'),
    accessorKey: 'id',
    enableSorting: false,
  },
  {
    header: i18n.t('Date'),
    accessorKey: 'date',
    enableSorting: true,
    sortingFn: 'datetime',
  },
  {
    header: i18n.t('Type'),
    accessorKey: 'type',
    enableSorting: false,
  },
  {
    header: i18n.t('Sub type'),
    accessorKey: 'eventSubType',
    enableSorting: false,
    enableGlobalFilter: false,
  },
  {
    header: i18n.t('Content'),
    accessorKey: 'content',
    enableSorting: false,
  },
  {
    header: i18n.t('Created by'),
    accessorKey: 'createdBy',
    enableSorting: false,
  },
  {
    header: i18n.t('Pairing ID'),
    accessorKey: 'pairingId',
    enableSorting: false,
  },
  {
    header: i18n.t('Resident'),
    id: 'resident',
    accessorFn: event => event.resident,
    enableSorting: false,
  },
  {
    header: i18n.t('User'),
    id: 'user',
    accessorFn: event => event.user,
    enableSorting: false,
  },
  // Search helper
  {
    header: i18n.t('Type'),
    id: 'translatedType',
    accessorFn: event => eventTypes[event.type],
  },
  {
    header: i18n.t('Sub type'),
    id: 'translatedEventSubType',
    accessorFn: event => eventSubTypes[event.eventSubType],
  },
  {
    header: i18n.t('Shared'),
    accessorKey: 'isSharedToAuthorizedRelative',
    enableSorting: false,
  },
];
